<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-2">
      <!-- Gender Filter -->
      <div class="col-6 col-md-2 col-lg-2">
        <select 
          class="form-select form-select-sm" 
          v-model="genderFilter" 
          @change="handleGenderFilter"
        >
          <option value="">{{ t('guardians.filters.allGenders') }}</option>
          <option value="M">{{ t('guardians.filters.male') }}</option>
          <option value="F">{{ t('guardians.filters.female') }}</option>
        </select>
      </div>
      
      <!-- Relation Filter -->
      <div class="col-6 col-md-2 col-lg-2">
        <select 
          class="form-select form-select-sm" 
          v-model="relationFilter" 
          @change="handleRelationFilter"
        >
          <option value="">{{ t('guardians.filters.allRelations') }}</option>
          <option value="father">{{ t('guardians.filters.father') }}</option>
          <option value="mother">{{ t('guardians.filters.mother') }}</option>
          <option value="uncle">{{ t('guardians.filters.uncle') }}</option>
          <option value="aunt">{{ t('guardians.filters.aunt') }}</option>
        </select>
      </div>
      
      <!-- Reset Button (Desktop) -->
      <div class="col-md-1 d-none d-md-block">
        <button 
          class="btn btn-outline-secondary btn-sm w-100" 
          @click="resetFilters"
          :title="t('guardians.filters.reset')"
        >
          <i class="fas fa-filter-circle-xmark"></i>
        </button>
      </div>
      
      <!-- Search Input -->
      <div class="col-12 col-md-4 col-lg-4 position-relative">
        <input
          type="text"
          class="form-control form-control-sm ps-5"
          :placeholder="t('guardians.filters.searchPlaceholder')"
          v-model="searchTerm"
          @input="handleSearch"
          style="padding-right: 12px;" 
        />
        <span class="position-absolute start-0 top-50 translate-middle-y ps-3">
          <i class="fas fa-search"></i>
        </span>
      </div>
      
      <!-- Reset Button (Mobile) -->
      <div class="col-12 d-md-none">
        <button class="btn btn-outline-secondary btn-sm w-100" @click="resetFilters">
          <i class="fas fa-filter-circle-xmark"></i> {{ t('guardians.filters.reset') }}
        </button>
      </div>
      
      <!-- Add Button -->
      <div class="col-12 col-md-3 col-lg-3">
        <button class="btn btn-secondary btn-sm w-100" @click="$emit('add')" v-can="'guardians.create'">
          <i class="fas fa-plus"></i>
          {{ t('guardians.filters.addGuardian') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { debounce } from 'lodash';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const searchTerm = ref('');
const genderFilter = ref('');
const relationFilter = ref('');

const emit = defineEmits(['search', 'gender', 'relation', 'add']);

const handleSearch = debounce(() => {
  emit('search', searchTerm.value);
}, 300);

const handleGenderFilter = () => {
  emit('gender', genderFilter.value);
};

const handleRelationFilter = () => {
  emit('relation', relationFilter.value);
};

const resetFilters = () => {
  searchTerm.value = '';
  genderFilter.value = '';
  relationFilter.value = '';
  emit('search', '');
  emit('gender', '');
  emit('relation', '');
};
</script>
